import { z } from "zod";

export const LoginSchema = z.object({
	username: z
		.string({ required_error: "Tu usuario es requerido" })
		.min(1, { message: "El usuario es obligatorio." }),
	password: z.string().min(1, { message: "La contraseña es obligatoria." }),
});

export type LoginInput = z.infer<typeof LoginSchema>;
